/** Локальная подсказка для refresh; подпись JWT проверяет сервер. */
export function accessExpiresSoon(token: string | null, nowSeconds = Date.now() / 1000): boolean {
  try {
    const payload = token?.split('.')[1];
    if (!payload) return true;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='))) as { exp?: unknown };
    return typeof exp !== 'number' || !Number.isFinite(exp) || exp - nowSeconds <= 60;
  } catch {
    return true;
  }
}
